import { useEffect, useState } from "react";
import { Row, Col, Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { useMenuItems } from "../../components/hooks/useMenuItems";
import HeaderEstandar from "../../components/layout/headers/HeaderEstandar";
import AppLayout from "../../components/layout/AppLayout";
import ActionResultModal from "../../components/actionResultModal.js/ActionResultModal";
import "./index.css";
import TareaActivaWidget from "./widget/TareaActivaWidget";
import GETOperacionEnProceso from "../../helpers/ordenes/GETOperacionEnProceso";
import { mapOperacionActiva } from "./widget/mapOperacionActiva";

const Home = ({ darkMode, setDarkMode }) => {
  const { loggedUser } = useAuth();
  const navigate = useNavigate();
  const [operacionActiva, setOperacionActiva] = useState(null);
  const [operacionVerificada, setOperacionVerificada] = useState(false);

  const [modal, setModal] = useState({
    open: false,
    message: "",
    type: "success",
    orden: null,
    modalType: "auditoria",
  });

  // Cargar operación en proceso
  useEffect(() => {
    const fetchData = async () => {
      const response = await GETOperacionEnProceso();
      if (response?.status === 200) {
        const dataEstandarizada = mapOperacionActiva(response.data);
        setOperacionActiva(dataEstandarizada);
      }
      setOperacionVerificada(true); // marca como lista, incluso si no hay operación
    };
    fetchData();
  }, []);

  // Cargar menú
  const { items: displayedMenuItems, ready: menuReady } = useMenuItems(
    false,
    false,
  );

  if (!menuReady || !operacionVerificada) {
    return null; // no renderizamos nada hasta que todo esté listo
  }

  const handleOptionClick = async (opt) => {
    navigate(opt.path);
  };

  const closeModal = () =>
    setModal({ open: false, message: "", type: "success", modalType: null });

  const headerComponent = <HeaderEstandar data={{ headerTitle: "Inicio" }} />;

  return (
    <AppLayout
      darkMode={darkMode}
      setDarkMode={setDarkMode}
      header={headerComponent}
    >
      <div
        style={{
          height: "100%",
          padding: "16px",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Typography.Title
          level={2}
          style={{ margin: "1rem", textAlign: "center" }}
        >
          Hola {loggedUser?.nombre}
        </Typography.Title>

        {/* Solo mostramos el widget si hay operación */}
        {operacionActiva && (
          <TareaActivaWidget
            operacionActiva={operacionActiva}
            setOperacionActiva={setOperacionActiva}
          />
        )}

        <Row gutter={[12, 12]}>
          {displayedMenuItems.map((opt) => (
            <Col key={opt.key} xs={12} sm={12}>
              <Button
                className="home-btn"
                block
                size="large"
                style={{
                  height: "130px",
                  backgroundColor: opt.color || "#1890ff",
                  borderColor: opt.color || "#1890ff",
                  fontSize: "19px",
                  color: "#fff",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.9")}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = "1")}
                onClick={() => handleOptionClick(opt)}
              >
                {opt.label}
              </Button>
            </Col>
          ))}
        </Row>

        <ActionResultModal
          open={modal.open}
          onClose={closeModal}
          type={modal.type}
          message={modal.message}
          orden={modal.orden}
          modalType={modal.modalType}
        />
      </div>
    </AppLayout>
  );
};

export default Home;
